import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IFillFeature as ICommonFillFeature } from './base/types';
import type { AngleFrom, NumberInputFrom } from '@tencent/wb-ext-form';

export interface IFillFeature extends ICommonFillFeature {
    getFillDirectionOptions();
    getColorSelectButton(): JSX.Element;
    handleSolidOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean): void;
    handleGradualOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean): void;
    handleAngleChange(value: number, dragEnd?: boolean, from?: AngleFrom): void
}

export const IFillFeature = Symbol.for('chart-fill-feature');

DynamicLoaderRegistry.merge(IFillFeature, {
    useFactory: async () => {
        const { ChartFillFeature } = await import('./fill-feature');
        return ChartFillFeature;
    },
    on: loadTask,
});
